import constants from 'constants/index'

const chooseStepsObject = (step) => {
  return (
    constants.incidents.CHOOSE_WHICH_INCIDENT_MANAGEMENT_DRIVER_STEP_OBJECT[
      step
    ] || []
  )
}

const driverJs = {
  chooseStepsObject,
}

export default driverJs
